import TabsPage from "./TabsPage";

export default TabsPage;
